import useGroupEconomic from '@core/services/business/group-economic/useGroupEconomic';
import axios from 'axios';
import defaultConfig from '../../defaultConfig';

const axiosIns = axios.create( {
  baseURL: defaultConfig.businessService,
  headers: {
    "Content-Type": "application/json",
    crossdomain: true,
    "Access-Control-Allow-Origin": "*",
  }
} );

const { groupEconomic } = useGroupEconomic( axiosIns, {} );
export default groupEconomic;
